// Small pieces for showing stored values (24 DES-561 items 4 and 5; decision record 0071).
import { Fragment } from 'react';
import { breakPoints, jsonText, NAME_BREAKS } from '../lib/tidy';

/** A piece longer than this may still break inside, so that it never runs past its box. */
const WHOLE_MAX = 32;

/**
 * A long name, value or path that breaks only where `at` allows: a setting's name at its dots,
 * underscores and commas (the default), a value at its commas, a path at its slashes. With
 * `whole`, each short piece is also kept on one line, so a browser never breaks it at a hyphen
 * ("2026-10-" / "14.md").
 */
export function Breakable({
  text,
  at = NAME_BREAKS,
  whole = false,
}: {
  text: string;
  at?: RegExp;
  whole?: boolean;
}) {
  return (
    <>
      {breakPoints(text, at).map((part, i) => (
        <Fragment key={i}>
          {i > 0 && <wbr />}
          {whole && part.length <= WHOLE_MAX ? <span className="whole">{part}</span> : part}
        </Fragment>
      ))}
    </>
  );
}

/** A stored value as a block of JSON, its fractions tidied and its long lines wrapped. */
export function Json({ v }: { v: unknown }) {
  if (v === null || v === undefined) return <span className="muted">—</span>;
  return <pre>{jsonText(v)}</pre>;
}
